export const EXPERIENCE_WORK = 'Work'
export const EXPERIENCE_EDUCATION = 'Education'
export const EXPERIENCE_OTHER = 'Other'

export const EXPERIENCE_EDIT = 'Edit'
export const EXPERIENCE_DELETE = 'Delete'
